module.exports = "/static/assets/7a3d188d587d856da4a6914fcfe82f65.png";